import type { ServiceIntervalConfig } from '../../../types';

// True when the current draft config matches the manufacturer default for the part —
// gates whether the reset-to-default action should be offered.
export const isAtOemDefault = ({
    current,
    oem
}: {
    current: ServiceIntervalConfig;
    oem: ServiceIntervalConfig;
}): boolean => current.unit === oem.unit && current.value === oem.value;
